"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@near-wallet-selector/core");
const near_wallet_1 = require("@near-wallet-selector/near-wallet");
const my_near_wallet_1 = require("@near-wallet-selector/my-near-wallet");
const wallet_1 = require("../wallet");
window.Buffer = require('buffer/').Buffer;
class NearWalletBase {
    constructor() {
        this.walletOptions = {
            signInRequired: true,
            type: wallet_1.WalletType.Browser,
            changableNetwork: true,
        };
        this.networkName = 'testnet';
        this.iconUrl = '';
    }
    initialize(walletEventsHandler) {
        return __awaiter(this, void 0, void 0, function* () {
            this.walletEventsHandler = walletEventsHandler;
            const selector = yield this.getWalletSelector();
            this.wallet = yield selector.wallet(this.getWalletId());
        });
    }
    finalizer() {
        throw new Error("Method not implemented.");
    }
    connectToContract(contractData) {
        return __awaiter(this, void 0, void 0, function* () {
            /* const selector = await this.getWalletSelector()
            this.accountId = selector.store.getState().accounts[0].accountId; */
        });
    }
    trustedMint(tokenId, salt, signature) {
        return __awaiter(this, void 0, void 0, function* () {
            const transactionResult = yield this.wallet.signAndSendTransaction({
                actions: [{
                        type: "FunctionCall",
                        params: {
                            methodName: "set_greeting",
                            args: { greeting: 'new greeting!' },
                            gas: "30000000000000",
                            deposit: "0",
                        }
                    }]
            });
            console.log(transactionResult);
            return transactionResult;
        });
    }
    isTokenExists(tokenId) {
        throw new Error("Method not implemented.");
    }
    isTokenOwner(tokenId) {
        throw new Error("Method not implemented.");
    }
    isSignedIn() {
        return __awaiter(this, void 0, void 0, function* () {
            const selector = yield this.getWalletSelector();
            console.log('isSignedIn networkId', selector.options.network.networkId);
            return selector.isSignedIn();
        });
    }
    signIn(contractData) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.wallet.signIn({ contractId: contractData["token"] });
        });
    }
    signOut() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.wallet.signOut();
        });
    }
    setNetwork(networkName) {
        return __awaiter(this, void 0, void 0, function* () {
            this.networkName = networkName;
            yield this.walletEventsHandler();
        });
    }
    getAccountAddress() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const selector = yield this.getWalletSelector();
            return (_a = selector.store.getState().accounts[0]) === null || _a === void 0 ? void 0 : _a.accountId;
        });
    }
    getWalletSelector() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, core_1.setupWalletSelector)({
                network: this.networkName,
                modules: [
                    (0, near_wallet_1.setupNearWallet)(),
                    (0, my_near_wallet_1.setupMyNearWallet)()
                ],
            });
        });
    }
    getWalletId() {
        throw new Error("Method is abstract");
    }
}
exports.default = NearWalletBase;
